export const formatCurrency = (
  amount: number | string,
  options?: { locale?: string; negative?: boolean },
) => {
  const defaultOptions = { locale: 'ko-KR', negative: false }
  const { locale, negative } = { ...defaultOptions, ...options }

  const number = typeof amount === 'string' ? Number(amount) : amount

  const formattedNumber = number.toLocaleString(locale)

  if (number > 0 && negative) {
    return `-${formattedNumber}`
  }

  return formattedNumber
}

export const commaStringToNumber = (value: string): number => {
  return Number(value.replaceAll(/,/g, ''))
}

/**
 * 전화번호를 하이픈(-)으로 구분하여 포맷팅합니다.
 * @param phoneNumber - 포맷팅할 전화번호
 * @returns 포맷팅된 전화번호
 *
 * @example
 * formatPhoneNumber('0212345678') // '02-1234-5678'
 * formatPhoneNumber('01012345678') // '010-1234-5678'
 * formatPhoneNumber('1234567890') // '123-456-7890'
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return phoneNumber

  return phoneNumber.replace(
    /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
    '$1-$2-$3',
  )
}
